<template>
  <div class="cf-card cf-flex cf-flex--column cf-flex--gap-12">
    <h3 class="cf-title cf-title--3">
      Save your receipt?
    </h3>

    <cf-formatted-content :content="content.PayAtTableQrCodeAndWallet.metadata.saveToWalletSubtitle" />

    <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-16 cf-mobile-column">
      <a
        v-if="receipt.applePassUrl"
        class="cf-cursor-pointer"
        target="_system"
        @click="addToAppleWalletHandler"
      >
        <img
          style="height: var(--input-height)"
          src="/images/apple-wallet.svg"
        >
      </a>

      <a
        v-if="receipt.googleWalletJwt"
        target="_blank"
        class="cf-cursor-pointer"
        :href="`https://pay.google.com/gp/v/save/${receipt.googleWalletJwt}`"
      >
        <img
          style="height: var(--input-height)"
          src="/images/google-pay-save.svg"
        >
      </a>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import { downloadOrderRedemptionAppleWalletPass } from '@/services/api/order-redemption';
  import events from '@/services/events';
  import logger from '@/services/logger';

  import CfFormattedContent from '@/view/components/globals/cf-formatted-content/index.vue';


  export default {
    name: 'SaveReceiptToWallet',

    components: {
      CfFormattedContent
    },

    props: {
      receipt: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('content', ['content'])
    },

    methods: {
      async addToAppleWalletHandler() {
        try {
          const paramObject = this.receipt.applePassUrl
            .split('?')[1]
            .split('&')
            .reduce((obj, param) => {
              const [key, value] = param.split('=');
              obj[key] = value;
              return obj;
            }, {});

          await downloadOrderRedemptionAppleWalletPass(paramObject);
        }

        catch (error) {
          logger.error(error);

          events.emit('notification', {
            clickToDismiss: false,
            duration: 3500,
            message: 'There was an issue generating your pass',
            type: 'error'
          });
        }
      }
    }
  };
</script>
